import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId, attributeId, value) => (
  axios.delete(`${config.designBuilderSetItemAttributePath}/${designId}/items/${itemId}/attribute`, { attributeId, value })
);
